import { useEffect, useState } from "react";
import { Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenProvidersReportPubSub, OpenProvidersReportPubSubPayload } from "@utils/pubsubs/PubSub";
import EntityReportForm, { ReportColumn } from "@components/forms/EntityReportForm";
import { ProviderApi, ProviderDataType } from "@/api/ProviderApi";

type ProvidersReportOffCanvasProps = {} & DefaultOffCanvasProps;

const providerColumns: ReportColumn<ProviderDataType>[] = [
  { key: "codigo", header: "Código", value: (p) => p.codigo },
  { key: "nombre", header: "Nombre", value: (p) => p.nombre },
  { key: "nombre_comercial", header: "Nombre Comercial", value: (p) => p.nombre_comercial },
  { key: "tipo_identificacion", header: "Tipo Identificación", value: (p) => p.tipo_identificacion },
  { key: "identificacion", header: "Identificación", value: (p) => p.identificacion },
  { key: "email", header: "Email", value: (p) => p.email },
  { key: "telefono1", header: "Teléfono 1", value: (p) => p.telefono1 },
  { key: "telefono2", header: "Teléfono 2", value: (p) => p.telefono2 },
  { key: "direccion", header: "Dirección", value: (p) => p.direccion },
  { key: "contacto", header: "Contacto", value: (p) => p.contacto },
  { key: "cuentas_bancarias", header: "Cuentas Bancarias", value: (p) => p.cuentas_bancarias },
  { key: "plazo", header: "Plazo", value: (p) => p.plazo },
];

const loadAllProviders = async (): Promise<ProviderDataType[]> => {
  const all: ProviderDataType[] = [];
  let token: string | undefined = undefined;
  do {
    const { items, nextToken } = await ProviderApi.fetchAll({}, token, 1000, null, { noCache: true });
    all.push(...items);
    token = nextToken;
  } while (token);
  return all;
};

const ProvidersReportOffCanvas = (props: ProvidersReportOffCanvasProps) => {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = OpenProvidersReportPubSub.subscribe(openOffCanvas);
    return () => {
      unsubscribe();
    };
  }, []);

  const openOffCanvas = async (payload: OpenProvidersReportPubSubPayload) => {
    const { openOffCanvas = false } = payload;
    setOpen(openOffCanvas);
  };

  const onCanvasClosed = () => {
    setOpen(false);
  };

  return (
    <DefaultOffCanvas
      className={styles.offCanvas}
      direction="end"
      isOpen={isOpen}
      onClosed={onCanvasClosed}
      toggle={() => setOpen(!isOpen)}
    >
      <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
        Reporte de Proveedores
      </OffcanvasHeader>
      <OffcanvasBody>
        <Container>
          <EntityReportForm<ProviderDataType>
            columns={providerColumns}
            loadRecords={loadAllProviders}
            fileName="proveedores.xlsx"
          />
        </Container>
      </OffcanvasBody>
    </DefaultOffCanvas>
  );
};

export default ProvidersReportOffCanvas;
